import { DOCUMENT, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonContent } from '@ionic/angular/standalone';
import { GlobalService } from '../../shared/services/global-data/global.service';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonContent, NgTemplateOutlet]
})
export class PrivacyPolicyComponent {
  private readonly document = inject(DOCUMENT);
  protected readonly globalService = inject(GlobalService);

  scrollToSection(sectionId: string): void {
    this.document.getElementById(sectionId)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}
